"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBrowserInfoNamingForMangopay = transformBrowserInfoNamingForMangopay;
function transformBrowserInfoNamingForMangopay(browserInfo) {
    return {
        AcceptHeader: browserInfo.acceptHeader,
        JavaEnabled: browserInfo.javaEnabled,
        Language: mapLanguageCode(browserInfo.language),
        ColorDepth: browserInfo.colorDepth,
        ScreenHeight: browserInfo.screenHeight,
        ScreenWidth: browserInfo.screenWidth,
        TimeZoneOffset: browserInfo.timeZoneOffset,
        UserAgent: browserInfo.userAgent,
        JavascriptEnabled: browserInfo.javascriptEnabled,
    };
}
// addressing the issue of language code not being in the formate expected by Mangopay
// https://app.shortcut.com/daytrip/story/43597/mangopay-payment-fails-due-to-language-code-es-419
function mapLanguageCode(language) {
    // remove any region code
    return language.split("-")[0];
}
//# sourceMappingURL=transformBrowserInfoNamingForMangopay.js.map